if (!Enum) {
    var Enum = {};
}

Enum.DRUG_PAYMENT_TYPE = {
    B: 'B',
    R: 'R',
    _30: '_30',
    _50: '_50',
    _100: '_100'
};

Object.freeze(Enum.DRUG_PAYMENT_TYPE);